// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_Z4R","cls2":"AnalyticsV2NavBar-cls2_4Up AnalyticsV2NavBar-cls1_Z4R"};